var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-text-lg tw-font-semibold tw-text-gray-880"},[_vm._v(" Total : "),_c('OvertimeBreakdownDetailsText',{attrs:{"breakdowns":_vm.breakdowns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }